import axios from '@/libs/api.request'

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getList = (params) => {
  return axios.request({
    url: 'LhcManage/LhcAmBBSZhiliao/index',
    method: 'get',
    params: params
  })
}




/**
 * 删除数据
 */
export const del = (id) => {
  return axios.request({
    url: 'LhcManage/LhcAmBBSZhiliao/del',
    method: 'get',
    params: {
      id: id
    }
  })
}


/**
* 锁定/解锁
*/
export const lock = (id) => {
return axios.request({
url: 'LhcManage/LhcAmBBSZhiliao/lock',
method: 'get',
params: {
id: id
}
})
}


// /**
//  * 获取列表
//  * @returns {wx.RequestTask | never}
//  */
// export const getParams = (id,key) => {
//   return axios.request({
//     url: 'LhcManage/LhcAmBBSZhiliao/getParams',
//     method: 'get',
//     params: {
//       id: id,
//       key: key
//     }
//   })
// }


/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const getParams = (data) => {
  return axios.request({
    url: 'LhcManage/LhcAmBBSZhiliao/getParams',
    method: 'post',
    data
  })
}

/**
 * 改变状态按钮
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const changeStatus = (status, id) => {
  return axios.request({
    url: 'LhcManage/LhcAmBBSZhiliao/changeStatus',
    method: 'get',
    params: {
      status: status,
      id: id
    }
  })
}

/**
 * 改变状态按钮
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const yulan = ( id) => {
  return axios.request({
    url: 'LhcManage/LhcAmBBSZhiliao/yulan',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const add = (data) => {
  return axios.request({
    url: 'LhcManage/LhcAmBBSZhiliao/add',
    method: 'post',
    data
  })
}

/**
 * 编辑
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const edit = (data) => {
  return axios.request({
    url: 'LhcManage/LhcAmBBSZhiliao/edit',
    method: 'post',
    data
  })
}
